import {colors} from '../../../foundation/colors';

export const MuiButton = {
  root: {
    borderRadius: '3px',
    padding: '4px 12px',
    minWidth: '56px',
    '&:hover': {
      backgroundColor: colors.blackAlpha[50],
    },
    '&:focus': {
      backgroundColor: colors.blackAlpha[50],
    },
    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
  containedSizeSmall: {
    padding: '1px 8px',
  },
  containedSizeLarge: {
    padding: '7px 22px',
  },
  containedPrimary: {
    '&:focus': {
      backgroundColor: '#004D96',
    },
  },
  outlined: {
    padding: '3px 11px',
    border: `1px solid ${colors.blackAlpha[600]}`,
  },
  outlinedPrimary: {
    '&:hover': {
      border: '1px solid rgba(46, 120, 199, 0.5)',
    },
    '&:focus': {
      backgroundColor: 'rgba(46, 120, 199, 0.04)',
      border: '1px solid rgba(46, 120, 199, 0.5)',
    },
  },
  outlinedSizeSmall: {
    padding: '0 7px',
  },
  outlinedSizeLarge: {
    padding: '6px 20px',
  },
  outlinedSecondary: {
    border: '1px solid rgba(117, 117, 117, 0.5)',
    '&:hover': {
      border: `1px solid ${colors.gray[500]}`,
      backgroundColor: colors.blackAlpha[50],
    },
    '&:focus': {
      border: `1px solid ${colors.gray[500]}`,
      backgroundColor: colors.blackAlpha[50],
    },
    '&.Mui-disabled': {
      border: `1px solid ${colors.gray[400]}`,
    },
  },
  text: {
    padding: '3px 11px',
  },
  textPrimary: {
    color: '#2E78C7',
    '&:hover': {
      backgroundColor: 'rgba(46, 120, 199, 0.04)',
    },
    '&:focus': {
      backgroundColor: 'rgba(46, 120, 199, 0.04)',
    },
  },
  textSizeSmall: {
    padding: '1px 8px',
  },
  textSizeLarge: {
    padding: '7px 22px',
  },
  iconSizeSmall: {
    '&> *:first-child': {
      fontSize: '1.12rem',
    },
  },
  endIcon: {
    marginLeft: '4px',
  },
  startIcon: {
    marginRight: '4px',
  },
};
